import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Music2 } from "lucide-react";
import { LOGO_MAIN } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0b0b0f] text-[#e8dfcc] mt-24">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-70" />
      <div className="max-w-7xl mx-auto container-px py-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 space-y-5">
          <img src={LOGO_MAIN} alt="DOTAPAN" className="h-16 w-auto" />
          <p className="font-display italic text-gold-soft text-lg">Pasiune pentru fiecare creație.</p>
          <p className="text-sm text-white/70 max-w-sm leading-relaxed">
            Din 2019, în Beclean, lucrăm cu aluatul așa cum se cuvine: cu răbdare, cu rețete bune și cu respect pentru
            partenerii noștri din HoReCa.
          </p>
          <div className="flex items-center gap-3 pt-2">
            <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:border-gold hover:text-gold transition-all">
              <Facebook className="h-4 w-4" />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:border-gold hover:text-gold transition-all">
              <Instagram className="h-4 w-4" />
            </a>
            <a href="https://tiktok.com" target="_blank" rel="noreferrer" aria-label="TikTok" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:border-gold hover:text-gold transition-all">
              <Music2 className="h-4 w-4" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:border-gold hover:text-gold transition-all">
              <Linkedin className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="lg:col-span-2">
          <h4 className="text-sm uppercase tracking-[0.25em] text-gold mb-5">Linkuri utile</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/despre-noi" className="hover:text-gold transition-colors">Despre noi</Link></li>
            <li><Link to="/produse" className="hover:text-gold transition-colors">Produse</Link></li>
            <li><Link to="/horeca" className="hover:text-gold transition-colors">HoReCa</Link></li>
            <li><Link to="/inovatie" className="hover:text-gold transition-colors">Inovație</Link></li>
            <li><Link to="/blog" className="hover:text-gold transition-colors">Blog</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="text-sm uppercase tracking-[0.25em] text-gold mb-5">Categorii</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/produse" className="hover:text-gold transition-colors">Produse coapte</Link></li>
            <li><Link to="/produse" className="hover:text-gold transition-colors">Produse congelate</Link></li>
            <li><Link to="/croissante" className="hover:text-gold transition-colors">Croissante</Link></li>
            <li><Link to="/blat-pizza" className="hover:text-gold transition-colors">Blat pizza</Link></li>
            <li><Link to="/produse" className="hover:text-gold transition-colors">Patiserie & Cofetărie</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="text-sm uppercase tracking-[0.25em] text-gold mb-5">Contact</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 text-gold mt-0.5 shrink-0" />
              <span>DOTAPAN SRL<br />Strada Parcului nr. 9<br />Beclean, Bistrița-Năsăud</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-gold shrink-0" />
              <a href="tel:+40740433894" className="hover:text-gold transition-colors">+40 740 433 894</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-gold shrink-0" />
              <a href="mailto:dotapanromania@gmail.com" className="hover:text-gold transition-colors">dotapanromania@gmail.com</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto container-px py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} DOTAPAN SRL. Toate drepturile rezervate.</p>
          <div className="flex items-center gap-5">
            <Link to="/termeni" className="hover:text-gold transition-colors">Termeni și condiții</Link>
            <Link to="/politica-confidentialitate" className="hover:text-gold transition-colors">Politică de confidențialitate</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
